import { set_show_filter } from '../confg';
import { createAction } from '@reduxjs/toolkit';

export const set_show_filter_action = createAction(set_show_filter);
